import { ReactNode } from 'react'
import { FolderSearchResult, SearchParams, SearchResult } from '../../types'
import { DataTableProps } from '../../ui/DataTable'

export type SearchRecord = Record<string, any>

interface FolderSearchResults<T extends SearchRecord> {
    type: 'folder'
    results: FolderSearchResult<T> | null
}

interface DefaultSearchResults<T extends SearchRecord> {
    type?: 'default'
    results: SearchResult<T> | null

}

type SearchResults<T extends SearchRecord> = FolderSearchResults<T> | DefaultSearchResults<T>

export type SearchTableProps<T extends SearchRecord> = {
    title?: ReactNode
    description?: ReactNode
    actions?: ReactNode
    type?: 'default' | 'folder'
    params: SearchParams
    setParams: (params: SearchParams) => void
    reload?: () => Promise<void>
    filters?: ReactNode[]
    enableSearch?: boolean
    searchPlaceholder?: string
} & Omit<DataTableProps<T>, 'items'> & SearchResults<T>

export const DEFAULT_ITEMS_PER_PAGE = 25
export const DEFAULT_PAGE = 1

export interface SearchTableQueryState<T> {
    results: T | null
    params: SearchParams
    reload: () => Promise<void>
    setParams: (params: SearchParams) => void
}
